import { useEffect } from 'react'
import { I18n } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Image } from '../../../../common/image'
import iconThankYou from '../../../../common/order/popup/popupConfirmation/location.svg'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { formatDateTime } from '../../../../helpers/datetime'

export const PopupActivateResult = ({
  isBuyPackage,
  isBuySubscription,
  userType,
  startDatePackage,
  endDatePackage,
  startDateSubscription,
  endDateSubscription,
  timer,
  isShow,
  setIsShow,
}) => {
  const startDate = () => {
    if (isBuySubscription) {
      return formatDateTime(startDateSubscription)
    }

    if (isBuyPackage) {
      return formatDateTime(startDatePackage)
    }
  }

  const endDate = () => {
    if (isBuySubscription) {
      return formatDateTime(endDateSubscription)
    }

    if (isBuyPackage) {
      return formatDateTime(endDatePackage)
    }
  }

  const packageMess = `${I18n.t(
    'userManagement.paymentMethod.YOUR_PACKAGE',
  )} ${I18n.t('userManagement.paymentMethod.SUCCESSFULLY_TRIGGER')}`

  const subscriptionMess = `${I18n.t(
    'userManagement.paymentMethod.YOUR_ACCOUNT_UPGRADED',
  )} ${userType}.`

  const validMess = `${I18n.t('userManagement.paymentMethod.VALID')} ${I18n.t(
    'userManagement.paymentMethod.FROM',
  )} ${startDate()} ${I18n.t('userManagement.paymentMethod.TO')} ${endDate()}.`

  const mess = () => {
    if (isBuySubscription) {
      return subscriptionMess
    }

    if (isBuyPackage) {
      return packageMess
    }
  }

  const handleClose = () => {
    setIsShow(false)
  }

  useEffect(() => {
    setTimeout(() => {
      setIsShow(false)
    }, timer)
  }, [setIsShow])

  return (
    <PopupAction
      title="common.CONFIRMATION"
      isShow={isShow}
      handleClose={handleClose}
      btnCancel={{
        label: 'common.CLOSE',
        event: handleClose,
        isI18n: true,
      }}
    >
      <div className="dFlex">
        <Image
          src={iconThankYou}
          alt="location"
          style={{ width: 50, height: 43 }}
          className="mr3"
        />
        <Element elementName="span">{`${mess()} ${validMess}`}</Element>
      </div>
    </PopupAction>
  )
}
